/**
 * @generated SignedSource<<f278861b1c96fa34e5459f0aec56a190>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditCharacteristicActive_user$data = {
  readonly dId: any | null;
  readonly panelist: {
    readonly dId: any | null;
  } | null;
  readonly vpmUserId: number | null;
  readonly " $fragmentType": "EditCharacteristicActive_user";
};
export type EditCharacteristicActive_user$key = {
  readonly " $data"?: EditCharacteristicActive_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditCharacteristicActive_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditCharacteristicActive_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vpmUserId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PanelistNode",
      "kind": "LinkedField",
      "name": "panelist",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};
})();

(node as any).hash = "3d674e196f932f3077b96c7bac9c1dc8";

export default node;
